import useRandomIds from '@/shared/hooks/useRandomIds';

export const BitcoinLogo = (props?: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  const [clipPathId] = useRandomIds(BitcoinLogo.name, 1, [props]);

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <rect width="16" height="16" rx="3" fill="#FFBD82" />
        <rect
          x="0.5"
          y="0.5"
          width="15"
          height="15"
          rx="2.5"
          stroke="white"
          strokeOpacity="0.24"
          style={{ mixBlendMode: 'overlay' }}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.489 7.1128C11.6383 6.11319 10.8772 5.57582 9.83652 5.21734L10.1741 3.86323L9.34962 3.65781L9.02096 4.97624C8.80451 4.92224 8.58195 4.8713 8.36081 4.82082L8.69182 3.49372L7.86804 3.2883L7.53022 4.64194C7.35086 4.60109 7.17479 4.56071 7.00388 4.51822L7.00482 4.51399L5.86811 4.23016L5.64884 5.11052C5.64884 5.11052 6.26039 5.25067 6.24748 5.25936C6.58131 5.3427 6.64188 5.56361 6.63155 5.73874L6.24701 7.28136C6.27002 7.28723 6.29983 7.29568 6.3327 7.30883L6.24584 7.28723L5.70659 9.44821C5.66574 9.54963 5.56221 9.70176 5.32886 9.644C5.33707 9.65598 4.72975 9.49446 4.72975 9.49446L4.32056 10.4382L5.39342 10.7056C5.51454 10.7359 5.6342 10.7672 5.75254 10.798C5.82916 10.818 5.90523 10.8379 5.98079 10.8573L5.63968 12.2271L6.46299 12.4325L6.80105 11.0775C7.02572 11.1385 7.24404 11.1948 7.45768 11.2479L7.12103 12.5966L7.94528 12.802L8.28639 11.435C9.69191 11.701 10.749 11.5937 11.1934 10.3227C11.5519 9.29914 11.1758 8.70871 10.4363 8.32347C10.9749 8.19881 11.3805 7.84456 11.4888 7.1128H11.489ZM9.60543 9.75338C9.37143 10.6928 7.90066 10.3041 7.22831 10.1264L7.22824 10.1264C7.16806 10.1105 7.11428 10.0963 7.06836 10.0849L7.52098 8.27039C7.57713 8.2844 7.64574 8.2998 7.72345 8.31723C8.41902 8.47332 9.8445 8.79319 9.60566 9.75338H9.60543ZM7.86316 7.47587C8.42416 7.62554 9.64702 7.95177 9.86004 7.09837C10.0778 6.22531 8.88873 5.96217 8.308 5.83365C8.24271 5.8192 8.18511 5.80646 8.13807 5.79474L7.7277 7.44042C7.76653 7.45009 7.8121 7.46225 7.86316 7.47587Z"
          fill="#111111"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path
            d="M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const EthereumLogo = (props?: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  const [clipPathId, paint0Id] = useRandomIds(EthereumLogo.name, 2, [props]);

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <rect width="24" height="24" rx="4.5" fill="#202020" />
        <rect width="24" height="24" rx="4.5" fill={`url(#${paint0Id})`} fillOpacity="0.2" />
        <rect
          x="0.5"
          y="0.5"
          width="23"
          height="23"
          rx="4"
          stroke="white"
          strokeOpacity="0.15"
          style={{ mixBlendMode: 'overlay' }}
        />
        <path
          d="M12.0095 5.12808L11.9224 5.42411V14.0142L12.0095 14.1011L15.9969 11.7442L12.0095 5.12808Z"
          fill="#B0B0B0"
        />
        <path d="M12.0106 5.12772L8.02319 11.7438L12.0106 14.1008V9.93144V5.12772Z" fill="white" />
        <path
          d="M12.0105 15.399L11.9614 15.4588V18.5188L12.0105 18.6622L16.0003 13.0432L12.0105 15.399Z"
          fill="#A0A0A0"
        />
        <path d="M12.0099 18.6622V15.399L8.02246 13.0432L12.0099 18.6622Z" fill="white" />
        <path d="M12.0098 14.1021L15.9971 11.7452L12.0098 9.9328V14.1021Z" fill="#575757" />
        <path d="M8.02246 11.7452L12.0098 14.1021V9.9328L8.02246 11.7452Z" fill="#A9A9A9" />
      </g>
      <defs>
        <radialGradient
          id={paint0Id}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12 -7.5) rotate(90) scale(31.5)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <clipPath id={clipPathId}>
          <path
            d="M0 4.5C0 2.01472 2.01472 0 4.5 0H19.5C21.9853 0 24 2.01472 24 4.5V19.5C24 21.9853 21.9853 24 19.5 24H4.5C2.01472 24 0 21.9853 0 19.5V4.5Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PolkadotLogo = (props?: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 0H4C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0Z"
      fill="#101010"
    />
    <path
      d="M4 0.5H12C13.933 0.5 15.5 2.067 15.5 4V12C15.5 13.933 13.933 15.5 12 15.5H4C2.067 15.5 0.5 13.933 0.5 12V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="none"
      stroke="white"
      strokeOpacity="0.08"
    />
    <g transform="translate(2.8998 2)">
      <path
        d="M0.609774 2.56438C-0.184909 3.49011 -0.205863 4.7787 0.564636 5.43996C1.33514 6.10278 2.60373 5.88828 3.40003 4.96094C4.19468 4.03522 4.21567 2.74663 3.44516 2.08539C3.14373 1.82574 2.76331 1.70155 2.36678 1.70155C1.75102 1.70155 1.09335 2.00153 0.609774 2.56438Z"
        fill="#E5E7EB"
      />
      <path
        d="M0.379204 7.35427C-0.218819 8.06387 0.040698 9.26861 0.959498 10.0444C1.8783 10.8201 3.10982 10.8749 3.70785 10.1653C4.30587 9.45571 4.04635 8.25097 3.12755 7.47522C2.64074 7.06395 2.0669 6.85592 1.54624 6.85592C1.08362 6.85592 0.661293 7.02043 0.380817 7.35427"
        fill="#E5E7EB"
      />
      <path
        d="M5.77438 9.95081C4.69603 10.2911 3.95291 10.9846 4.11408 11.4991C4.2769 12.0135 5.28273 12.1555 6.36114 11.8136C7.43954 11.4733 8.1826 10.7798 8.02144 10.2653C7.91827 9.94114 7.47981 9.76376 6.89951 9.76376C6.55941 9.76376 6.17253 9.8234 5.77438 9.94921"
        fill="#E5E7EB"
      />
      <path
        d="M4.08666 0.661236C3.86422 1.30311 4.57024 2.13208 5.66638 2.5143C6.76246 2.89652 7.8312 2.68525 8.05361 2.04337C8.27607 1.40149 7.57007 0.572533 6.47394 0.190306C6.10479 0.0612848 5.73729 0 5.40525 0C4.75239 0 4.23334 0.235463 4.08666 0.661236Z"
        fill="#E5E7EB"
      />
      <path
        d="M9.01436 1.95486C8.6968 2.08227 8.77257 3.00961 9.18199 4.02243C9.5914 5.03688 10.1798 5.75454 10.4973 5.62713C10.8132 5.49972 10.7391 4.57399 10.3297 3.55956C9.95249 2.62416 9.42218 1.94035 9.09334 1.94035C9.06595 1.94035 9.04015 1.94519 9.01436 1.95486Z"
        fill="#E5E7EB"
      />
      <path
        d="M9.2577 8.11718C8.80637 9.09611 8.65001 9.98794 8.90953 10.1073C9.16906 10.2267 9.74615 9.52995 10.1975 8.55098C10.6504 7.57205 10.8052 6.68016 10.5472 6.56082C10.5279 6.55116 10.507 6.54795 10.4828 6.54795C10.2007 6.54795 9.67523 7.21242 9.2577 8.11718Z"
        fill="#E5E7EB"
      />
    </g>
  </svg>
);
export const ArbitrumLogo = (props?: React.SVGProps<SVGSVGElement>) => {
  const [clip0Id, filter0Id, paint0Id, paint1Id] = useRandomIds(ArbitrumLogo.name, 4, [props]);

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clip0Id})`}>
        <g filter={`url(#${filter0Id})`}>
          <rect width="16" height="16" rx="3" fill={`url(#${paint0Id})`} />
          <rect width="16" height="16" rx="3" fill={`url(#${paint1Id})`} fillOpacity="0.15" />
        </g>
        <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" stroke="white" strokeOpacity="0.08" />
        <path
          d="M3.90063 6.03986V9.96141C3.90063 10.2135 4.03269 10.4416 4.25277 10.5697L7.65012 12.5304C7.8662 12.6545 8.13431 12.6545 8.3504 12.5304L11.7477 10.5697C11.9638 10.4456 12.0999 10.2135 12.0999 9.96141V6.03986C12.0999 5.78776 11.9678 5.55967 11.7477 5.43162L8.3504 3.47084C8.13431 3.3468 7.8662 3.3468 7.65012 3.47084L4.25277 5.43162C4.03669 5.55567 3.90464 5.78776 3.90464 6.03986H3.90063Z"
          fill="#213147"
        />
        <path
          d="M8.73856 8.7609L8.25436 10.0894C8.24236 10.1254 8.24236 10.1655 8.25436 10.2055L9.08669 12.4904L10.0511 11.9342L8.89462 8.7609C8.86661 8.68887 8.76657 8.68887 8.73856 8.7609Z"
          fill="#12AAFF"
        />
        <path
          d="M9.71127 6.52839C9.68326 6.45636 9.58322 6.45636 9.55521 6.52839L9.07102 7.85691C9.05901 7.89293 9.05901 7.93294 9.07102 7.97296L10.4356 11.7144L11.3999 11.1582L9.71127 6.53239V6.52839Z"
          fill="#12AAFF"
        />
        <path
          d="M7.99845 3.61887C8.02246 3.61887 8.04647 3.62688 8.06648 3.63888L11.7399 5.75972C11.7839 5.78373 11.808 5.83175 11.808 5.87977V10.1214C11.808 10.1695 11.7799 10.2175 11.7399 10.2415L8.06648 12.3623C8.04647 12.3743 8.02246 12.3823 7.99845 12.3823C7.97444 12.3823 7.95043 12.3743 7.93042 12.3623L4.25697 10.2415C4.21295 10.2175 4.18894 10.1695 4.18894 10.1214V5.87576C4.18894 5.82775 4.21696 5.77973 4.25697 5.75572L7.93042 3.63488C7.95043 3.62287 7.97444 3.61487 7.99845 3.61487V3.61887ZM7.99845 2.99863C7.8664 2.99863 7.73835 3.03064 7.6183 3.09867L3.94485 5.21951C3.70875 5.35556 3.5647 5.60366 3.5647 5.87576V10.1174C3.5647 10.3895 3.70875 10.6376 3.94485 10.7737L7.6183 12.8945C7.73435 12.9626 7.8664 12.9946 7.99845 12.9946C8.1305 12.9946 8.25855 12.9626 8.3786 12.8945L12.0521 10.7737C12.2881 10.6376 12.4322 10.3895 12.4322 10.1174V5.87576C12.4322 5.60366 12.2881 5.35556 12.0521 5.21951L8.3746 3.09867C8.25855 3.03064 8.1265 2.99863 7.99445 2.99863H7.99845Z"
          fill="#9DCCED"
        />
        <path
          d="M5.56519 11.7181L5.90532 10.7898L6.58559 11.354L5.94934 11.9382L5.56519 11.7181Z"
          fill="#213147"
        />
        <path
          d="M7.68605 5.57541H6.75368C6.68565 5.57541 6.62163 5.61943 6.59762 5.68346L4.60083 11.1576L5.56521 11.7138L7.76608 5.68346C7.78609 5.62743 7.74607 5.57141 7.69005 5.57141L7.68605 5.57541Z"
          fill="white"
        />
        <path
          d="M9.31831 5.57553H8.38594C8.31791 5.57553 8.25389 5.61955 8.22988 5.68358L5.94897 11.934L6.91336 12.4903L9.39434 5.68358C9.41434 5.62756 9.37433 5.57153 9.31831 5.57153V5.57553Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id={filter0Id}
          x="0"
          y="0"
          width="16.9599"
          height="16.9599"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.959909" dy="0.959909" />
          <feGaussianBlur stdDeviation="3.1197" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3759_3480" />
        </filter>
        <linearGradient id={paint0Id} x1="8" y1="0" x2="8" y2="16" gradientUnits="userSpaceOnUse">
          <stop stopColor="#213147" />
          <stop offset="1" stopColor="#2F4664" />
        </linearGradient>
        <radialGradient
          id={paint1Id}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(3.99864) rotate(45) scale(12.5706)"
        >
          <stop stopColor="#7887E6" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <clipPath id={clip0Id}>
          <path
            d="M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SolanaLogo = (props?: React.SVGProps<SVGSVGElement>) => {
  const [
    clip0Id,
    filter0Id,
    paint0Id,
    paint1Id,
    paint2Id,
    paint3Id,
    paint4Id,
    paint5Id,
    paint6Id,
    paint7Id,
  ] = useRandomIds(SolanaLogo.name, 10, [props]);

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clip0Id})`}>
        <g filter={`url(#${filter0Id})`}>
          <rect
            x="-0.000244141"
            y="0.0323792"
            width="16.0344"
            height="16.0344"
            rx="3"
            fill={`url(#${paint0Id})`}
          />
          <rect
            x="-0.000244141"
            y="0.0323792"
            width="16.0344"
            height="16.0344"
            rx="3"
            fill={`url(#${paint1Id})`}
            fillOpacity="0.15"
          />
        </g>
        <path
          d="M4.87421 10.1584C4.90627 10.1264 4.95064 10.1075 4.99795 10.1075H12.8389C12.8443 10.1075 12.8462 10.1088 12.8471 10.1094C12.8486 10.1105 12.8507 10.1127 12.8522 10.1162C12.8537 10.1197 12.8537 10.1228 12.8534 10.1246C12.8532 10.1257 12.8528 10.128 12.849 10.1317L12.9526 10.2352L12.849 10.1317L11.3001 11.6806C11.268 11.7127 11.2237 11.7316 11.1764 11.7316H3.33539C3.33006 11.7316 3.32809 11.7303 3.32722 11.7297C3.32568 11.7286 3.32359 11.7264 3.32213 11.7229C3.32066 11.7193 3.32057 11.7163 3.32089 11.7145C3.32107 11.7134 3.32153 11.7111 3.32529 11.7074L4.87421 10.1584Z"
          fill={`url(#${paint2Id})`}
          stroke={`url(#${paint3Id})`}
          strokeWidth="0.292842"
        />
        <path
          d="M4.77043 4.27222C4.83219 4.21293 4.91372 4.17834 4.99771 4.17834H12.8387C12.982 4.17834 13.0536 4.35127 12.9523 4.45256L11.4034 6.00148C11.3441 6.06077 11.2626 6.09536 11.1761 6.09536H3.33514C3.19186 6.09536 3.12022 5.92243 3.22151 5.82114L4.77043 4.27222Z"
          fill={`url(#${paint4Id})`}
        />
        <path
          d="M4.87277 4.37695C4.90892 4.34269 4.95432 4.32477 4.99771 4.32477H12.8387C12.844 4.32477 12.846 4.32607 12.8469 4.32668C12.8484 4.32777 12.8505 4.32998 12.8519 4.33352C12.8534 4.33706 12.8535 4.34009 12.8532 4.34193C12.853 4.34297 12.8525 4.34527 12.8488 4.34902L12.9517 4.45194L12.8488 4.34902L11.2999 5.89795C11.2678 5.93 11.2234 5.94894 11.1761 5.94894H3.33514C3.32982 5.94894 3.32785 5.94763 3.32697 5.94702C3.32544 5.94594 3.32335 5.94372 3.32188 5.94018C3.32042 5.93665 3.32033 5.93361 3.32065 5.93177C3.32083 5.93073 3.32129 5.92843 3.32504 5.92468L4.87277 4.37695Z"
          stroke={`url(#${paint5Id})`}
          strokeOpacity="0.5"
          strokeWidth="0.292842"
        />
        <path
          d="M11.1764 7.19726C11.2237 7.19726 11.268 7.21619 11.3001 7.24825L12.849 8.79718C12.8528 8.80093 12.8532 8.80323 12.8534 8.80427C12.8537 8.80611 12.8537 8.80914 12.8522 8.81268C12.8507 8.81622 12.8486 8.81843 12.8471 8.81951C12.8462 8.82013 12.8443 8.82143 12.8389 8.82143H4.99795C4.95064 8.82143 4.90627 8.8025 4.87421 8.77044L3.32529 7.22152C3.32153 7.21777 3.32107 7.21547 3.32089 7.21443C3.32057 7.21259 3.32066 7.20955 3.32213 7.20602C3.32359 7.20248 3.32568 7.20026 3.32722 7.19918C3.32809 7.19857 3.33006 7.19726 3.33539 7.19726H11.1764Z"
          fill={`url(#${paint6Id})`}
          stroke={`url(#${paint7Id})`}
          strokeWidth="0.292842"
        />
      </g>
      <defs>
        <filter
          id={filter0Id}
          x="-0.000244141"
          y="0.0323792"
          width="16.747"
          height="16.747"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.712563" dy="0.712563" />
          <feGaussianBlur stdDeviation="2.31583" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3759_3483" />
        </filter>
        <linearGradient
          id={paint0Id}
          x1="5.33309"
          y1="-0.000172973"
          x2="14.6664"
          y2="14.6665"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#ECECEC" />
        </linearGradient>
        <radialGradient
          id={paint1Id}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.01697 0.0323792) rotate(90) scale(10.2531)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id={paint2Id}
          x1="12.0899"
          y1="3.25259"
          x2="6.66331"
          y2="13.6467"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset="1" stopColor="#DC1FFF" />
        </linearGradient>
        <linearGradient
          id={paint3Id}
          x1="3.17432"
          y1="10.9195"
          x2="13"
          y2="10.9195"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DF59F3" />
          <stop offset="1" stopColor="#91B4E0" />
        </linearGradient>
        <linearGradient
          id={paint4Id}
          x1="9.71684"
          y1="2.01426"
          x2="4.29027"
          y2="12.4083"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset="1" stopColor="#DC1FFF" />
        </linearGradient>
        <linearGradient
          id={paint5Id}
          x1="3.17407"
          y1="5.13685"
          x2="12.9998"
          y2="5.13685"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D4B5E8" />
          <stop offset="0.229137" stopColor="#67C9D7" />
          <stop offset="1" stopColor="#17F3C6" />
        </linearGradient>
        <linearGradient
          id={paint6Id}
          x1="10.8959"
          y1="2.62917"
          x2="5.46935"
          y2="13.0232"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset="1" stopColor="#DC1FFF" />
        </linearGradient>
        <linearGradient
          id={paint7Id}
          x1="3.17432"
          y1="8.00935"
          x2="13"
          y2="8.00935"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B293E9" />
          <stop offset="1" stopColor="#6EC6D8" />
        </linearGradient>
        <clipPath id={clip0Id}>
          <path
            d="M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const TronLogo = (props?: React.SVGProps<SVGSVGElement>) => {
  const [clip0Id, filter0Id] = useRandomIds(TronLogo.name, 2, [props]);
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clip0Id})`}>
        <g filter={`url(#${filter0Id})`}>
          <path
            d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z"
            fill="#FF060A"
          />
        </g>
        <path
          d="M2 0.235352H14C14.9748 0.235352 15.7646 1.02522 15.7646 2V14C15.7646 14.9748 14.9748 15.7646 14 15.7646H2C1.02522 15.7646 0.235352 14.9748 0.235352 14V2C0.235352 1.02522 1.02522 0.235352 2 0.235352Z"
          stroke="white"
          strokeOpacity="0.16"
          strokeWidth="0.47"
        />
        <path
          d="M12.4844 6.54722C12.043 6.15488 11.43 5.55718 10.9334 5.13419L10.9028 5.1158C10.8537 5.07902 10.7986 5.04837 10.7403 5.02691C9.53878 4.81235 3.94798 3.81006 3.8407 3.82232C3.81005 3.82538 3.7794 3.83764 3.75488 3.85297L3.72729 3.87442C3.69357 3.90814 3.66599 3.94799 3.65066 3.99396L3.64453 4.01235V4.1135V4.12883C4.27288 5.80852 6.75871 11.3074 7.24913 12.6009C7.27978 12.6897 7.33495 12.8553 7.43917 12.8645H7.46369C7.51886 12.8645 7.75794 12.561 7.75794 12.561C7.75794 12.561 12.0277 7.60163 12.4599 7.07442C12.515 7.01006 12.5641 6.93956 12.607 6.86599C12.6192 6.80776 12.6131 6.74952 12.5917 6.69435C12.5702 6.63917 12.5304 6.58707 12.4844 6.54722ZM8.84913 7.12653L10.6698 5.67979L11.7395 6.62385L8.84913 7.12653ZM8.14108 7.03151L5.00545 4.56714L10.0813 5.46523L8.14108 7.03151ZM8.42308 7.67519L11.6323 7.17864L7.9633 11.4177L8.42308 7.67519ZM4.5794 4.81542L7.88055 7.49741L7.40238 11.4208L4.5794 4.81542Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id={filter0Id}
          x="-4"
          y="-4"
          width="24"
          height="24"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="-4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6885_14878" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="4.7" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0" />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_6885_14878"
            result="effect2_innerShadow_6885_14878"
          />
        </filter>
        <clipPath id={clip0Id}>
          <rect width="16" height="16" rx="2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const AssethubLogo = (props?: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(-5 -5)">
      <path
        d="M25 5H9C6.79086 5 5 6.79086 5 9V25C5 27.2091 6.79086 29 9 29H25C27.2091 29 29 27.2091 29 25V9C29 6.79086 27.2091 5 25 5Z"
        fill="#101010"
      />
      <path
        d="M9 5.5H25C26.933 5.5 28.5 7.067 28.5 9V25C28.5 26.933 26.933 28.5 25 28.5H9C7.067 28.5 5.5 26.933 5.5 25V9C5.5 7.067 7.067 5.5 9 5.5Z"
        fill="none"
        stroke="white"
        strokeOpacity="0.08"
      />
      <path
        d="M10.813 12.4192C9.75346 13.6535 9.72552 15.3716 10.7528 16.2533C11.7802 17.137 13.4716 16.851 14.5333 15.6146C15.5929 14.3803 15.6209 12.6622 14.5935 11.7805C14.1916 11.4343 13.6844 11.2687 13.1557 11.2687C12.3347 11.2687 11.4578 11.6687 10.813 12.4192Z"
        fill="#E5E7EB"
      />
      <path
        d="M10.5058 18.8057C9.70845 19.7518 10.0545 21.3581 11.2795 22.3925C12.5046 23.4268 14.1466 23.4999 14.944 22.5537C15.7413 21.6076 15.3953 20.0013 14.1702 18.967C13.5212 18.4186 12.7561 18.1412 12.0619 18.1412C11.445 18.1412 10.8819 18.3606 10.508 18.8057"
        fill="#E5E7EB"
      />
      <path
        d="M17.6992 22.2678C16.2614 22.7215 15.2705 23.6461 15.4854 24.3321C15.7025 25.0181 17.0436 25.2073 18.4815 24.7514C19.9194 24.2977 20.9101 23.3731 20.6952 22.6871C20.5577 22.2549 19.973 22.0184 19.1993 22.0184C18.7459 22.0184 18.23 22.0979 17.6992 22.2656"
        fill="#E5E7EB"
      />
      <path
        d="M15.4489 9.88165C15.1523 10.7375 16.0937 11.8428 17.5552 12.3524C19.0166 12.862 20.4416 12.5803 20.7381 11.7245C21.0348 10.8687 20.0934 9.76338 18.6319 9.25374C18.1397 9.08171 17.6497 9 17.207 9C16.3365 9 15.6445 9.31395 15.4489 9.88165Z"
        fill="#E5E7EB"
      />
      <path
        d="M22.0192 11.6064C21.5958 11.7763 21.6968 13.0128 22.2427 14.3632C22.7886 15.7158 23.5731 16.6727 23.9965 16.5028C24.4177 16.3329 24.3189 15.0986 23.773 13.746C23.2701 12.4988 22.563 11.5871 22.1245 11.5871C22.088 11.5871 22.0536 11.5935 22.0192 11.6064Z"
        fill="#E5E7EB"
      />
      <path
        d="M22.3436 19.8229C21.7419 21.1281 21.5334 22.3172 21.8794 22.4763C22.2255 22.6355 22.9949 21.7066 23.5967 20.4013C24.2006 19.096 24.4069 17.9068 24.063 17.7477C24.0373 17.7348 24.0093 17.7306 23.9771 17.7306C23.6009 17.7306 22.9003 18.6165 22.3436 19.8229Z"
        fill="#E5E7EB"
      />
    </g>
  </svg>
);

export const BscLogo = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6885_15304)">
      <g filter="url(#filter0_ii_6885_15304)">
        <rect width="16" height="16" rx="3" fill="#F0B90B" />
      </g>
      <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" stroke="white" strokeOpacity="0.16" />
      <path
        d="M4.35286 8L4.35866 10.1275L6.16643 11.1913V12.4369L3.30069 10.7561V7.37786L4.35286 8ZM4.35286 5.87247V7.11224L3.30005 6.48945V5.24968L4.35286 4.62689L5.41083 5.24968L4.35286 5.87247ZM6.92139 5.24968L7.9742 4.62689L9.03217 5.24968L7.9742 5.87247L6.92139 5.24968Z"
        fill="white"
      />
      <path
        d="M5.11353 9.68656V8.44098L6.16634 9.06377V10.3035L5.11353 9.68656ZM6.92129 11.6374L7.9741 12.2602L9.03207 11.6374V12.8772L7.9741 13.5L6.92129 12.8772V11.6374ZM10.542 5.24968L11.5948 4.62689L12.6528 5.24968V6.48945L11.5948 7.11224V5.87247L10.542 5.24968ZM11.5948 10.1275L11.6006 8L12.6534 7.37722V10.7555L9.78767 12.4362V11.1907L11.5948 10.1275Z"
        fill="white"
      />
      <path d="M10.8397 9.68655L9.78687 10.3035V9.06377L10.8397 8.44098V9.68655Z" fill="white" />
      <path
        d="M10.8398 6.31345L10.8456 7.55902L9.03272 8.62279V10.7555L7.97991 11.3725L6.92709 10.7555V8.62279L5.11417 7.55902V6.31345L6.17149 5.69066L7.97346 6.75958L9.78638 5.69066L10.8444 6.31345H10.8398ZM5.11353 4.18656L7.9741 2.5L10.8398 4.18656L9.78703 4.80934L7.9741 3.74042L6.16634 4.80934L5.11353 4.18656Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_ii_6885_15304"
        x="-4"
        y="-4"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" dy="-4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6885_15304" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="4" />
        <feGaussianBlur stdDeviation="4.7" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0" />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_6885_15304"
          result="effect2_innerShadow_6885_15304"
        />
      </filter>
      <clipPath id="clip0_6885_15304">
        <rect width="16" height="16" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const ChainflipLogo = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3865_4920)">
      <rect width="16" height="16" rx="3" fill="#15211B" fillOpacity="0.36" />
      <rect width="16" height="16" rx="3" fill="url(#paint0_radial_3865_4920)" fillOpacity="0.2" />
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="2.5"
        stroke="white"
        strokeOpacity="0.32"
        style={{ mixBlendMode: 'overlay' }}
      />
      <path
        d="M12.1999 3.79999V7.3815C12.1999 8.01821 11.9985 8.63503 11.6349 9.14241C11.5218 9.30158 11.3941 9.44584 11.2516 9.58015L11.2418 9.58512H9.56125V6.26725H8.00359H6.43118H6.29359H4.74084L4.7605 6.24735L6.07739 5.00875L6.56385 4.55608C7.11419 4.03876 7.79229 3.79999 8.53919 3.79999H12.1999Z"
        fill="url(#paint1_linear_3865_4920)"
      />
      <path
        d="M11.2418 9.59003L11.2369 9.595L11.232 9.59997L11.1435 9.68454L10.8094 10.0029L9.59567 11.142L9.47774 11.2514C8.9274 11.7638 8.20507 12.0424 7.4631 12.0424H3.7876V10.4406L3.79251 9.58505L3.80234 8.44593C3.80725 7.61522 4.1463 6.82928 4.74578 6.26221H6.29853H6.30345V9.58505H11.2418V9.59003Z"
        fill="url(#paint2_linear_3865_4920)"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_3865_4920"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8 -5) rotate(90) scale(21)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_3865_4920"
        x1="8.64685"
        y1="3.44667"
        x2="8.1646"
        y2="12.5366"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.5458" stopColor="#F1F1F1" />
        <stop offset="0.6918" stopColor="#E3E3E3" />
        <stop offset="0.9662" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3865_4920"
        x1="7.73659"
        y1="12.4933"
        x2="6.47055"
        y2="3.17894"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.6103" stopColor="#B9B9B9" />
        <stop offset="1" />
      </linearGradient>
      <clipPath id="clip0_3865_4920">
        <path
          d="M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
